import { render, staticRenderFns } from "./PlantForm.vue?vue&type=template&id=c12eab48"
import script from "./PlantForm.vue?vue&type=script&lang=js"
export * from "./PlantForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports